import { useCallback } from 'react';
import { useAuthDispatch } from '@/providers';
import { SET_SESSION } from '@/actions/types';
import { clearAuthFailure, initiateSignIn, isUsableSession } from '@/services/auth';

export const useInitiateSignIn = () => {
  const auth_dispatch = useAuthDispatch();

  return useCallback(async () => {
    try {
      const session = await initiateSignIn();
      if (isUsableSession(session)) {
        clearAuthFailure();
        auth_dispatch({ type: SET_SESSION, session });
      }
    } catch (error) {
      console.error('Error initiating sign in:', error);
    }
  }, [auth_dispatch]);
};
